import React from 'react';
import { ExportContext } from './ExportContext';

export function useExport() {
  const exportBuidler = React.useContext(ExportContext)!;
  return exportBuidler;
}